import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { FormFieldComponentProps, getSafe, InputSelectComponent } from '@sheerid/jslib';
import { ClassGroupChoice, ClassIDChoice } from '../../../lib/types/types';
import { ClassGroupsEnum, ClassIDEnum } from '../../../lib/types/runtimeTypes';

interface ClassIDOptionsProps {
    onChange: (value: ClassIDChoice) => void;
    classGroup: ClassGroupChoice;
    fieldId: string;
    inputId: string;
}

export const ClassName = ({
    value,
    onChange,
    intl,
    placeholder,
    isErrored,
    classGroup,
    fieldId,
    inputId,
}: ClassIDOptionsProps & InjectedIntlProps & FormFieldComponentProps) => {
    const groupSelected = getSafe(() => classGroup.value) ? true : false;

    const getClassIDOptions = () => {
        const options: ClassIDChoice[] = [];

        switch (getSafe(() => classGroup.value, '')) {
            case ClassGroupsEnum.ARTS:
                Object.values([
                    ClassIDEnum.art1,
                    ClassIDEnum.art2,
                    ClassIDEnum.art3,
                    ClassIDEnum.art4,
                    ClassIDEnum.art5,
                    ClassIDEnum.art6,
                    ClassIDEnum.art7,
                    ClassIDEnum.art8,
                    ClassIDEnum.art9,
                    ClassIDEnum.art10,
                    ClassIDEnum.art11,
                    ClassIDEnum.art12,
                    ClassIDEnum.art13,
                    ClassIDEnum.art14,
                    ClassIDEnum.art15,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.BUSINESS:
                Object.values([
                    ClassIDEnum.biz1,
                    ClassIDEnum.biz2,
                    ClassIDEnum.biz3,
                    ClassIDEnum.biz4,
                    ClassIDEnum.biz5,
                    ClassIDEnum.biz6,
                    ClassIDEnum.biz7,
                    ClassIDEnum.biz8,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.EDUCATION:
                Object.values([
                    ClassIDEnum.edu1,
                    ClassIDEnum.edu2,
                    ClassIDEnum.edu3,
                    ClassIDEnum.edu4,
                    ClassIDEnum.edu5,
                    ClassIDEnum.edu6,
                    ClassIDEnum.edu7,
                    ClassIDEnum.edu8,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.HEALTH_PROFESSIONS:
                Object.values([
                    ClassIDEnum.hlth1,
                    ClassIDEnum.hlth2,
                    ClassIDEnum.hlth3,
                    ClassIDEnum.hlth4,
                    ClassIDEnum.hlth5,
                    ClassIDEnum.hlth6,
                    ClassIDEnum.hlth7,
                    ClassIDEnum.hlth8,
                    ClassIDEnum.hlth9,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.HUMANITIES:
                Object.values([
                    ClassIDEnum.humn1,
                    ClassIDEnum.humn2,
                    ClassIDEnum.humn3,
                    ClassIDEnum.humn4,
                    ClassIDEnum.humn5,
                    ClassIDEnum.humn6,
                    ClassIDEnum.humn7,
                    ClassIDEnum.humn8,
                    ClassIDEnum.humn9,
                    ClassIDEnum.humn10,
                    ClassIDEnum.humn11,
                    ClassIDEnum.humn12,
                    ClassIDEnum.humn13,
                    ClassIDEnum.humn14,
                    ClassIDEnum.humn15,
                    ClassIDEnum.humn16,
                    ClassIDEnum.humn17,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.PROTECTIVE_SERVICES:
                Object.values([
                    ClassIDEnum.protc1,
                    ClassIDEnum.protc2,
                    ClassIDEnum.protc3,
                    ClassIDEnum.protc4,
                    ClassIDEnum.protc5,
                    ClassIDEnum.protc6,
                    ClassIDEnum.protc7,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.SCIENCE_TECHNOLOGY_MATH:
                Object.values([
                    ClassIDEnum.scnc1,
                    ClassIDEnum.scnc2,
                    ClassIDEnum.scnc3,
                    ClassIDEnum.scnc4,
                    ClassIDEnum.scnc5,
                    ClassIDEnum.scnc6,
                    ClassIDEnum.scnc7,
                    ClassIDEnum.scnc8,
                    ClassIDEnum.scnc9,
                    ClassIDEnum.scnc10,
                    ClassIDEnum.scnc11,
                    ClassIDEnum.scnc12,
                    ClassIDEnum.scnc13,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            case ClassGroupsEnum.TRADES_SERVICES:
                Object.values([
                    ClassIDEnum.trad1,
                    ClassIDEnum.trad2,
                    ClassIDEnum.trad3,
                    ClassIDEnum.trad4,
                    ClassIDEnum.trad5,
                    ClassIDEnum.trad6,
                ]).map(classId => options.push({
                    value: classId,
                    label: intl.formatMessage({ id: `classNameOptions.${classId}`, defaultMessage: `${classId}` }),
                }));
                break;
            default:
                break;
        }
        return options;
    };

    const ClassIDOptions: ClassIDChoice[] = getClassIDOptions();

    return (
        <div className={`sid-class-name sid-field ${!groupSelected ? 'sid-input-disabled' : ''}`}>
            <div className="sid-l-space-top-sm" />
            <InputSelectComponent
                fieldId={fieldId}
                inputId={inputId}
                value={value}
                options={ClassIDOptions}
                onChange={(classId: ClassIDChoice) => onChange(classId)}
                placeholder={placeholder}
                isErrored={isErrored}
                disabled={!groupSelected}
            />
        </div>
    );
};

export const ClassNameComponent = injectIntl(ClassName);
